import clsx from "clsx";

import { type TileDescriptor } from "@features/metrics-explorer/types";

import { LegendItem } from "./legend-item";

interface Props {
  tiles: TileDescriptor[];
  onChange(id: string): void;
}

export const Legend = ({ tiles, onChange }: Props) => {
  return (
    <div
      className={clsx(
        "text-xs flex flex-wrap items-center justify-center gap-x-6 gap-y-4 px-[10%] mt-2",
      )}
    >
      {tiles.map((tile, index) => (
        <LegendItem
          key={tile.id}
          tile={tile}
          index={index}
          onChange={() => onChange(tile.id)}
        />
      ))}
    </div>
  );
};
